import { ServicePlanTaskInfo } from '../formData'

interface CustomTaskValidationsInput {
  tasks: ServicePlanTaskInfo[]
  inQA: boolean
}

interface CustomTaskValidations {
  taskErrors: string[]
  calculateTaskErrors: () => string[]
}

const MISSING_TASKS_DETAILS_MESSAGE = 'Please ensure that all tasks are completely filled out.'

export function isFilledServicePlanTask(task: ServicePlanTaskInfo): boolean {
  return Boolean(task.id && task.adl && task.directions && task.serviceType?.reference)
}

const calculateTaskErrorsUtil = ({ tasks, inQA }: CustomTaskValidationsInput): string[] => {
  if (inQA) {
    return []
  }

  const hasIncompleteTasks = tasks.some((t) => !isFilledServicePlanTask(t))

  const errors = [...(hasIncompleteTasks ? [MISSING_TASKS_DETAILS_MESSAGE] : [])]
  return errors
}

export const validateTasks = (
  tasks: ServicePlanTaskInfo[],
  inQA: boolean
): CustomTaskValidations => {
  const taskErrors = calculateTaskErrorsUtil({
    tasks,
    inQA
  })

  return {
    taskErrors,
    calculateTaskErrors: () => calculateTaskErrorsUtil({ tasks, inQA })
  }
}
